/* eslint-disable no-invalid-regexp */
/* eslint-disable no-useless-escape */
export const VALID_EMAIL_REGEX = new RegExp(
    /[\w-]+@([\w-]+\.)+[\w-]+/,
);

export const STRONG_PASSWORD_REGEX = new RegExp(
    '(?=.{8})((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*d)(?=.*[a-zA-Z])(?=.*[\\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\\W_])).*',
);

export const LOWER_CASE_LETTER_REGEX = new RegExp(
    '^(?=.*[a-z])',
);

export const UPPER_CASE_LETTER_REGEX = new RegExp(
    '(?=.*[A-Z])',
);

export const DIGIT_NUMBER_REGEX = new RegExp(
    '(?=.*[0-9])',
);

export const SPECIAL_CHARACTER_REGEX = new RegExp(
    '(?=.[!@#$%^&])',
);

export const VALID_NAME_REGEX = new RegExp(
    '^[a-zA-Z0-9_.-]*$',
);

export const PASSWORD_LENGTH_REGEX = new RegExp(
    '(?=.{8})',
);

export const VALID_MOBILE_NUMBER_REGEX = new RegExp(
    '(?=.*[0-9])',
);
